export default __webpack_public_path__ + "static/media/MealPlan.5bb11f3e.svg";